import { onMounted, onUnmounted } from 'vue'
import { useUserStore } from '~~/modules/auth/stores/userStore'

export const useFreshdeskBot = () => {
  useHead({
    script: [
      {
        type: 'text/javascript',
        tagPosition: 'bodyClose',
        src: '//eu.fw-cdn.com/13328892/1236204.js',
        chat: 'true',
      } as any,
    ],
  })

  const userStore = useUserStore()

  const waitForFreshdesk = (): Promise<void> => {
    return new Promise(resolve => {
      const checkFreshdesk = () => {
        if (window.fcWidget) {
          resolve()
        } else {
          setTimeout(checkFreshdesk, 100)
        }
      }
      checkFreshdesk()
    })
  }

  const sendUserToFreshdesk = async () => {
    if (userStore.getLogged.value !== true) return

    await waitForFreshdesk()

    const userData = userStore.getUserdata.value

    if (userData.name && window.fcWidget?.user) {
      window.fcWidget.user.setFirstName(userData.name)
    }

    if (userData.mail && window.fcWidget?.user) {
      window.fcWidget.user.setEmail(userData.mail)
    }
  }

  onMounted(() => {
    const unsubscribe = watch(
      () => userStore.state.value.logged,
      () => {
        sendUserToFreshdesk()
      },
    )

    sendUserToFreshdesk()

    onUnmounted(() => {
      unsubscribe()
    })
  })
}
